export default () => ({
  loading: false,
  services: [],
  service: {},
  profiles: {},
  games: {},
  unitListing: [],
})
